import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import history from '../../helpers/history';
import { Layout, Button } from 'antd';

import CountdownTimer from './CountdownTimer';

const { Content } = Layout;

var languageMessages = window.appLocale.messages;

class PageNotFoundPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            count: 3,
        }
    }

    onTimeUpdate = (count) => {
        if (count <= 0) {
            this.GoHome();
        }
    }

    GoHome = () => {
        history.push("/");
    }

    render() {
        return (<Content className='main-container total-content'><Helmet>
            <title>{languageMessages['title']}</title>
            <meta name="keywords" content={languageMessages['keywords']} />
            <meta name="description" content={languageMessages['description']} />

            <meta property="og:title" content={languageMessages['title']} />
            <meta property="og:url" content="https://us.quancept.com/" />
            <meta property="og:type" content="website" />
            <meta name="og:description" content={languageMessages['description']} />

            <meta property="twitter:url" content="https://us.quancept.com/" />
            <meta name="twitter:title" content={languageMessages['title']} />
            <meta name="twitter:description" content={languageMessages['description']} />
            <meta name="twitter:site" content="https://us.quancept.com/" />
        </Helmet>
            <div style={{ padding: '0px 50px', textAlign: 'center' }}>
                <h1 style={{ lineHeight: '200px', fontSize: 20 }}>404 - Not Found</h1>

                <CountdownTimer totalTimeLeft={this.state.count} onTimeUpdate={this.onTimeUpdate} />
                <div><Button size='small' onClick={this.GoHome}>Back home</Button></div>
            </div>
        </Content>);
    }
}

export { PageNotFoundPage as default }